<template>
  <div class="table__wrapper">
    <div class="table" :style="{ minWidth: width }">
      <div class="table__row--fields" :class="classType">
        <div v-for="field in fields" :key="field.id">
          <span>{{ field.name }}</span>
          <FieldNotice v-if="field.tooltip" :text="field.tooltip" />
        </div>
      </div>

      <component
        :is="dynamicComponent"
        :data="data"
        :row-class="classType"
        :account-address="accountAddress"
      />
    </div>
  </div>
</template>

<script>
import TableSlotBlock from "./TableSlotBlock.vue";
import TableSlotTx from "./TableSlotTx.vue";
import TableSlotBlockHome from "./TableSlotBlockHome.vue";
import TableSlotTxHome from "./TableSlotTxHome.vue";
import TableSlotTransfer from "./TableSlotTransfer.vue";
import TableSlotUnwrap from "./TableSlotUnwrap.vue";
import TableSloatRichAccount from "./TableSloatRichAccount.vue";
import FieldNotice from "./FieldNotice.vue";
import {
  blockTableFields,
  txTableFields,
  blockTableHomeFields,
  txTableHomeFields,
  transferTableFields,
  unwrapTableFields,
  richaccountsTableFields,
} from "../../../js/fields";

export default {
  props: ["width", "dataType", "data", "accountAddress", "view"],

  components: {
    TableSlotBlock,
    TableSlotBlockHome,
    TableSlotTx,
    TableSlotTxHome,
    TableSlotTransfer,
    TableSlotUnwrap,
    TableSloatRichAccount,
    FieldNotice,
  },

  computed: {
    classType() {
      let classType = `table__row--${this.dataType}`;

      if (this.view) {
        classType += `${this.view}`;
      }

      return classType;
    },

    fields() {
      switch (this.dataType) {
        case "blocks":
          if (this.view == "Home") {
            return blockTableHomeFields;
          }
          return blockTableFields;
        case "txs":
          if (this.view == "Home") {
            return txTableHomeFields;
          }
          return txTableFields;
        case "transfers":
          return transferTableFields;
          case "unwrap":
          return unwrapTableFields;
        case "richaccounts":
          return richaccountsTableFields;
      }
    },

    dynamicComponent() {
      switch (this.dataType) {
        case "blocks":
          if (this.view == "Home") {
            return TableSlotBlockHome;
          }
          return TableSlotBlock;
        case "txs":
          if (this.view == "Home") {
            return TableSlotTxHome;
          }
          return TableSlotTx;
        case "transfers":
          return TableSlotTransfer;
          case "unwrap":
          return TableSlotUnwrap;
        case "richaccounts":
          return TableSloatRichAccount;
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/contents/shared/Table.vue